import React from "react";
import styled from "styled-components";
import { formatDate } from "./helpers/dateFormatting";
import { style as styleConfig } from "config";
const CommentsContainer = styled.div ``;
const CommentBox = styled.div `
  background-color: ${styleConfig.colors.backgroundLightBlue};
  border: 1px solid ${styleConfig.colors.primary};
  padding: 1.5rem;
  margin-bottom: 1rem;
`;
const CommentHeader = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
`;
const CommentLabel = styled.span `
  font-weight: 600;
  color: ${styleConfig.colors.primary};
  font-size: 0.9rem;
`;
const CommentDate = styled.span `
  font-size: 0.85rem;
  color: ${styleConfig.colors.fontGray};
`;
const CommentText = styled.p `
  white-space: pre-wrap;
  line-height: 1.6;
  margin: 0;
`;
const SectionTitle = styled.h3 `
  font-size: 1.25rem;
  font-weight: 600;
  color: ${styleConfig.colors.primary};
  margin-bottom: 1rem;
`;
export default function LearningTaskAnswerVersionComments(props) {
    const { comments } = props;
    if (!comments || comments.length === 0) {
        return null;
    }
    return (React.createElement(CommentsContainer, null,
        React.createElement(SectionTitle, null, "Feedback vom Team"),
        comments.map((comment) => (React.createElement(CommentBox, { key: comment.id },
            React.createElement(CommentHeader, null,
                React.createElement(CommentLabel, null, "Triaphon-Team"),
                React.createElement(CommentDate, null, formatDate(comment.createdAt))),
            React.createElement(CommentText, null, comment.text))))));
}
